module.exports = require("core-js/library/fn/object/assign");


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/core-js/object/assign.js
// module id = ../node_modules/@babel/runtime/core-js/object/assign.js
// module chunks = 0